export default __webpack_public_path__ + "static/media/chat11.0f88ebc9.jpg";